<template>
  <div class="backdrop">
    <div class="title-box">
      <img src="../../../assets/images/return.png" @click="$router.go(-1)"><span>采购申请</span><img src="../../../assets/images/material-add.png" @click="sddRequisition">
    </div>
    <div class="common search-box">
      <input type="text" placeholder="请输入物品名称/条码" v-model="search_input">
      <div @click="getList()">搜索</div>
    </div>
    <div class="date-wrapper common">
      <span class="title">日期</span>
      <span>
        <img src="../../../assets/images/repair-left-arrow.png" @click="lastday1(date_time1)">
        <div @click="selectData1">{{date_time1}}</div>
        <mt-datetime-picker ref="datePicker1" type="date" v-model="pickerValue1" @confirm="handleConfirm1"></mt-datetime-picker>
        <img src="../../../assets/images/repair-right-arrow.png" @click="nextday1(date_time1)">
      </span>
      <span class="division">至</span>
      <span>
        <img src="../../../assets/images/repair-left-arrow.png" @click="lastday2(date_time2)">
        <div @click="selectData2">{{date_time2}}</div>
        <mt-datetime-picker ref="datePicker2" type="date" v-model="pickerValue2" @confirm="handleConfirm2"></mt-datetime-picker>
        <img src="../../../assets/images/repair-right-arrow.png" @click="nextday2(date_time2)">
      </span>
    </div>
    <div class="common order-wrapper">
      <div class="block">
        <div class="item">
          <span class="total">合计</span>
          <input type="checkbox" id="w_total" :checked="checkedAll == true" @click="isCheckedAll(checkedAll)">
          <label for="w_total" style="background-position: 50px 9px;"><span style="padding-left: 70px;">全选</span></label>
          <div><span>{{total_count}}</span>笔</div>
        </div>
      </div>
      <div class="block">
        <div class="item">
          <input type="checkbox" id="w_norecorded" :checked="checkeds.indexOf(1) >= 0" @click="isChecked(1)">
          <label for="w_norecorded"><span>未入账</span></label>
          <div><span class="orange">{{not_enter_count}}</span>笔</div>
        </div>
      </div>
      <div class="block">
        <div class="item">
          <input type="checkbox" id="w_recorded" :checked="checkeds.indexOf(2) >= 0" @click="isChecked(2)">
          <label for="w_recorded"><span>已入账</span></label>
          <div><span class="green">{{enter_count}}</span>笔</div>
        </div>
      </div>
      <div class="block">
        <div class="item">
          <input type="checkbox" id="w_recorded" :checked="checkeds.indexOf(2) >= 0" @click="isChecked(2)">
          <label for="w_recorded"><span>已完成</span></label>
          <div><span class="green">{{total_finish}}</span>笔</div>
        </div>
      </div>
    </div>
    <div class="common orderlist-wrapper" v-if="requisition_list.length > 0" v-for="(requisition, requisition_key) in requisition_list" :key="requisition_key">
      <div class="layout mar_bot" @click="toDetail(requisition.requisition_id)">
        <div class="flex-1 describe"><span>采购申请 {{requisition.requisition_num}}</span>{{requisition.applicant_member_name}}</div>
        <div class="date">{{requisition.create_time_info}}</div>
      </div>
      <div class="layout" @click="toDetail(requisition.requisition_id)">
        <div class="flex-1">件数{{requisition.requisition_count}}</div>
        <div class="status background_green" v-if="requisition.status === 1">已入账</div>
        <div class="status background_red" v-else>未入账</div>
      </div><div class="approval-row" v-if="requisition.approval">
        <div class="flex-1" style="color:blue" @click="$router.push({name: 'ApprovalInfo', query: {approval_id: requisition.approval.approval_id}})">{{requisition.approval.approval_status_name}}</div>
      </div>
    </div>
    <!-- 选择分类 -->
    <div class="purchase-box" v-if="purchaseBox">
      <div class="purchase-content"  style="margin-top: -40px;">
        <div class="purchase-goods">
          <div id="requisition-type">
            <span>申请分类：</span>
            <select v-model="requisition_type">
              <option value="">--请选择--</option>
              <option v-for="(item, item_key) in optList" :key="item_key" v-bind:value="item.id">{{ item.label }}</option>
            </select>
          </div>
        </div>
        <div class="purchase-button">
          <button @click="cancel">取消</button>
          <button @click="confirm">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
export default {
  name: 'RequisitionList',
  metaInfo: {
    title: '采购申请'
  },
  data () {
    return {
      date_time1: '',
      date_time2: '',
      pickerValue1: new Date(),
      pickerValue2: new Date(),
      checkedAll: true, // 默认全选状态
      checkeds: [1, 2, 3],
      allcheckeds: [1, 2, 3],
      total_count: 0,
      enter_count: 0,
      not_enter_count: 0,
      total_finish: 0,
      requisition_list: [],
      search_input: '',
      purchaseBox: false,
      requisition_type: '',
      optList: [{id: 1, label: '办公用品'}, {id: 2, label: '保洁'}, {id: 3, label: '工程'}, {id: 4, label: '绿化'}, {id: 5, label: '秩序'}, {id: 6, label: '固定资产'}],
      group_management_id: ''
    }
  },
  computed: {
    ...mapState(['villageId', 'memberId'])
  },
  created () {
    console.log(this.$route)
    if (this.group_management_id === '') {
      this.axios.post('/wechat/Index/getVillageInfo', {
        village_id: this.villageId
      }).then((res) => {
        if (res.data.status === 1) {
          var getVillageInfo = res.data.data
          this.group_management_id = getVillageInfo.group_management_id
        }
      })
    }
    this.date_time1 = this.getDate()
    this.date_time2 = this.getDate()
    this.getList()
  },
  methods: {
    ...mapMutations(['changeArgs']),
    // 获取当前时间
    getDate (type) {
      let date = new Date()
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      month = month > 9 ? month : '0' + month
      day = day > 9 ? day : '0' + day
      return `${year}-${month}-${day}`
    },
    // 打开时间选择器
    selectData1 () {
      this.$refs['datePicker1'].open()
      let a = document.getElementsByClassName('picker-solt')
      console.log(a.length)
      for (let i = 0; i < a.length; i++) {
        console.log(i)
        if (i === 2) {
          a[i].style.display = 'none'
        }
      }
    },
    // 打开时间选择器
    selectData2 () {
      this.$refs['datePicker2'].open()
      let a = document.getElementsByClassName('picker-solt')
      console.log(a.length)
      for (let i = 0; i < a.length; i++) {
        console.log(i)
        if (i === 2) {
          a[i].style.display = 'none'
        }
      }
    },
    // 选择时间点击确定按钮
    handleConfirm1 (val) {
      let date = val
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      month = month > 9 ? month : '0' + month
      day = day > 9 ? day : '0' + day
      let resDate = year + '-' + month + '-' + day
      this.date_time1 = resDate
      this.getList()
    },
    // 选择时间点击确定按钮
    handleConfirm2 (val) {
      let date = val
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      month = month > 9 ? month : '0' + month
      day = day > 9 ? day : '0' + day
      let resDate = year + '-' + month + '-' + day
      this.date_time2 = resDate
      this.getList()
    },
    // 上一个天
    lastday1 (type) {
      var date = new Date(type)
      date.setDate(date.getDate() - 1)
      var y = date.getFullYear()
      var m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      var d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      this.date_time1 = y + '-' + m + '-' + d
      this.getList()
      return y + '-' + m + '-' + d
    },
    // 下一个天
    nextday1 (type) {
      var date = new Date(type)
      date.setDate(date.getDate() + 1)
      var y = date.getFullYear()
      var m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      var d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      this.date_time1 = y + '-' + m + '-' + d
      this.getList()
      return y + '-' + m + '-' + d
    },
    // 上一个天
    lastday2 (type) {
      var date = new Date(type)
      date.setDate(date.getDate() - 1)
      var y = date.getFullYear()
      var m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      var d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      this.date_time2 = y + '-' + m + '-' + d
      this.getList()
      return y + '-' + m + '-' + d
    },
    // 下一个天
    nextday2 (type) {
      var date = new Date(type)
      date.setDate(date.getDate() + 1)
      var y = date.getFullYear()
      var m = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
      var d = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
      this.date_time2 = y + '-' + m + '-' + d
      this.getList()
      return y + '-' + m + '-' + d
    },
    // 是否全选
    isAllCheckeds: function () {
      if (this.checkeds.length === this.allcheckeds.length) {
        this.checkedAll = true
      } else {
        this.checkedAll = false
      }
    },
    // 全选
    isCheckedAll (checkedAll) {
      if (checkedAll === true) {
        this.checkedAll = false
        this.checkeds = []
      } else {
        this.checkedAll = true
        this.checkeds = [1, 2]
      }
      this.getList()
    },
    isChecked (checkedId) {
      let Index = this.checkeds.indexOf(checkedId)
      if (Index >= 0) {
        // 如果已经包含了该id, 则去除(单选按钮由选中变为非选中状态)
        this.checkeds.splice(Index, 1)
      } else {
        // 选中该checkbox
        this.checkeds.push(checkedId)
      }
      console.log(this.checkeds)
      this.isAllCheckeds() // 是否全选
      this.getList()
    },
    // 获取单据列表
    getList () {
      this.loading = true
      // 搜索条件有变化，需重新获取列表 和 统计数据
      this.requisition_list = []
      this.page = 0
      this.total_count = 0
      this.enter_count = 0
      this.not_enter_count = 0
      this.total_finish = 0
      // 统计数据
      this.axios.post('/wechat/Purchase/getRequisitionList', {
        member_id: this.memberId,
        village_id: this.villageId,
        start_time: this.date_time1,
        end_time: this.date_time2,
        goods_keywords: this.search_input
      }).then((res) => {
        console.log('getRequisitionList-1:')
        console.log(res)
        if (res.data.status === 1) {
          if (res.data.data.length !== 0) {
            this.total_count = res.data.data.total
            this.enter_count = res.data.data.total_enter
            this.not_enter_count = res.data.data.total_not_enter
            this.total_finish = res.data.data.total_finish
          }
        } else {
          this.$toast({
            message: res.data.message,
            duration: 5000
          })
        }
      })
      // 列表分页数据
      if (this.checkeds.length === 0) {
        this.requisition_list = []
        this.page = 0
        this.see_more = false
        this.loading = false
      } else {
        this.axios.post('/wechat/Purchase/getRequisitionList', {
          member_id: this.memberId,
          village_id: this.villageId,
          start_time: this.date_time1,
          end_time: this.date_time2,
          goods_keywords: this.search_input,
          status_checkeds: this.checkeds.join(','),
          page: this.page + 1
        }).then((res) => {
          if (res.data.status === 1) {
            if (res.data.data.length !== 0) {
              this.requisition_list = this.requisition_list.concat(res.data.data.requisition_list)
            }
            this.page = res.data.data.page
            if (this.requisition_list.length >= res.data.data.total) {
              this.see_more = false
            } else {
              this.see_more = true
            }
            this.loading = false
          } else {
            this.loading = false
            this.$toast({
              message: res.data.info,
              duration: 5000
            })
          }
        }).catch(() => {
          this.loading = false
          this.$toast({
            message: '网络错误',
            duration: 5000
          })
        })
      }
    },
    // 详情
    toDetail: function (requisitionId) {
      console.log(requisitionId)
      this.$router.push({name: 'RequisitionDetail', query: {requisition_id: requisitionId}})
    },
    sddRequisition: function () {
      if ([1, 11].indexOf(this.group_management_id) === -1) {
        this.$router.push({name: 'RequisitionSelecteGoods'})
      } else {
        this.purchaseBox = true
      }
      // this.$router.push({name: 'RequisitionSelecteGoods'})
    },
    // 取消
    cancel () {
      this.purchaseBox = false
    },
    // 确定
    confirm () {
      if (this.requisition_type === '') {
        this.$toast({
          message: '请选择申请分类',
          duration: 5000
        })
        return false
      } else {
        this.$router.push({name: 'RequisitionSelecteGoods', query: {requisition_type: this.requisition_type}})
      }
    }
  }
}
</script>
<style scoped>
.common {
  padding: 15px 10px;
}
.date-wrapper {
  font-size: 15px;
  color: #000000;
}
.date-wrapper .title {
  padding-right: 10px;
}
.date-wrapper .division {
  padding: 0 5px;
}
.date-wrapper span {
  line-height: 18px;
}
.date-wrapper img {
  width: 18px;
  height: 18px;
  vertical-align: top;
}
.date-wrapper div {
  display: inline-block;
  padding: 0 2px;
}
.order-wrapper {
  display: flex;
  font-size: 14px;
}
.order-wrapper .block {
  flex: 1;
}
.order-wrapper .block .item {
  margin: 0 4px;
  background-color: #f4f4f4;
  position: relative;
  padding: 0 5px;
}
.order-wrapper .block .item input {
  position: absolute;
  top: 0;
  left: 0;
  visibility: hidden;
}
.order-wrapper .block .item input:checked+label {
  background-image: url(../../../assets/images/checked.png);
}
.order-wrapper .block .item label {
  background-repeat: no-repeat;
  background-image: url(../../../assets/images/unchecked.png);
  background-position: 5px 9px;
  background-size: 16px 16px;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.order-wrapper .block .item label span:last-child {
  padding: 7px 0 0 26px;
  display: block;
}
.order-wrapper .block .item div {
  padding: 30px 0 5px 0;
}
.order-wrapper .block .item div span {
  font-size: 17px;
  font-weight: 700;
  padding-right: 4px;
}
.order-wrapper .block .item .total {
  position: absolute;
  top: 7px;
  left: 5px;
}
.orderlist-wrapper {
  font-size: 15px;
  color: #313131;
}
.orderlist-wrapper .layout {
  display: flex;
}
.orderlist-wrapper .layout .flex-1 {
  flex: 1;
}
.orderlist-wrapper .layout .describe span {
  padding-right: 15px;
}
.orderlist-wrapper .layout .date {
  color: #8c8c8c;
  padding-top: 2px;
}
.orderlist-wrapper .layout .status {
  color: #fff;
  padding: 0 9px;
  border-radius: 12px;
  font-size: 14px;
  display: inline-block;
}
.orderlist-wrapper .approval-row {
  margin-top: 10px;
  border-top: 1px solid #f4f4f4;
  padding: 7px 0px 0px 0px;
  font-size: 13px;
}
.orderlist-wrapper .approval-row label {
  color: #999;
  display: inline-block;
  width: 64px;
}
.mar_bot {
  margin-bottom: 8px;
}
.background_green {
  background-color: #35c53b;
}
.background_red {
  background-color: #ff5148;
}
.green {
  color: #35c53b;
}
.orange {
  color: #fa6b2c;
}
.purchase-box {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
  z-index: 2;
  align-items: center;
  justify-content: center;
  display: flex;
}
.purchase-box .purchase-content {
  background-color: #ffffff;
  border-radius: 5px;
  width: 70%;
}
.purchase-box .purchase-content .purchase-goods {
  padding: 15px;
  display: flex;
  font-size: 14px;
  color: #8f8f8f;
  height: 40px;
  margin-top: 15px;;
}
.purchase-box .purchase-content .purchase-button {
  display: flex;
  font-size: 16px;
}
.purchase-box .purchase-content .purchase-button button {
  flex: 1;
  height: 40px;
  background-color: #f7f7f7;
  border: none;
  margin: 0;
}
.purchase-box .purchase-content .purchase-button button:first-child {
  border-bottom-left-radius: 5px;
  border-top: 1px solid #f1f1f1;
}
.purchase-box .purchase-content .purchase-button button:last-child {
  background-color: #ff7c12;
  color: #ffffff;
  border-bottom-right-radius: 5px;
}
#requisition-type {
  margin-left: 10px;
}
#requisition-type span {
  font-size: 15px;
  color: #313131;
}
#requisition-type select {
  font-size: 15px;
  color: #313131;
  width: 130px;
  border-radius: 5px;
  background-color: #f8f8f8;
  border: 1px solid #888787;
}
</style>



// WEBPACK FOOTER //
// src/components/Material/purchase/RequisitionList.vue